<template>
  <div class="search-result__inner">
    <div class="search-result__main">
      <h1>{{ firstTitlePart }}</h1>
      <p
        v-html="getFieldValue(result.Fields, 'Description', 'Unknown', true)"
      ></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchResult",
  props: {
    result: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getFieldValue(
      fields,
      fieldName,
      defaultValue = undefined,
      returnHighlights = false
    ) {
      // Assign field to a constant
      const field = fields[fieldName];
      // Verify that the field exists
      if (field) {
        // Assign field value to variable so it can be trimmed
        let fieldValue = field.Value;
        // Initialise field higlights with trimmed field value
        let fieldHighlights = fieldValue;
        // Verify that highlights exist on this field
        if (field.Highlights && field.Highlights.length > 0) {
          // Update field higlights to the first highlight only
          fieldHighlights = field.Highlights.join(" ");
        }
        // Return trimmed field value or joined highlights
        return returnHighlights ? fieldHighlights : fieldValue;
      }
      // The field does not exist, return the default string
      return defaultValue;
    },
    capitalise(string = "") {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getYears(yearLength) {
      return `${yearLength} year${yearLength !== 1 ? "s" : ""}`;
    },
  },
  computed: {
    firstTitlePart() {
      const title = this.result?.Fields?.Title?.Value;
      if (typeof title === 'string' && title.includes('|')) {
        return title.split('|')[0].trim();
      }
      return title || ''; // fallback if no pipe or empty
    }
  }
};
</script>

<style></style>
